import { SCOPE_NAME } from '.';
// System User Info
export var getUserDataRedux = function (state) {
    return state[SCOPE_NAME].userData;
};
export var getUserMenusRedux = function (state) {
    return state[SCOPE_NAME].userMenus;
};
export var getApplicationCodesRedux = function (state) {
    return state[SCOPE_NAME].applicationCodes;
};
export var getUserInfoRedux = function (state) {
    return state[SCOPE_NAME].userInfo;
};
export var getTaskItemRedux = function (state) {
    return state[SCOPE_NAME].taskItem;
};
